import { Box, Typography } from "@mui/material";
import React from "react";
import { DialogStyle } from "../../app/admin/dealership/dialog/dialogBody/Dialog.styles";
import { ErrorOutlineOutlined } from "@mui/icons-material";
import Theme from "../../../utils/Theme";

const AccessDenied = () => {
  return (
    <Box padding={"24px"}>
      <Box
        sx={{
          // backgroundColor: "#FBF2D6",
          flexDirection: "row",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "4px",
        }}
        gap="6px"
      >
        {/* <ErrorOutlineOutlined sx={DialogStyle.error} /> */}
        <Typography variant="body2" color={Theme.palette.error.main}>
          Access denied. You do not have permission to perform this action.
        </Typography>
      </Box>
    </Box>
  );
};

export default AccessDenied;
